export class User {
    id: string;
    username: string;
    first_name: string;
    last_name: string;
    token?: string;
    email: string;
    address: string;
    last_login: string;
    role: string;
    postal_code: string;
    birth: string;
    gender: string;
    disease: string;
    family_disease: string;
    race: string;
    state: string;
    city: string;
    progress: number;

}
